export const MicroAppToOperationsRoleIdentifier: Record<string, string> = {
  payouts_management: 'treasury',
  balances_management: 'treasury',
  reports: 'settlement'
}

export const OPERATORS_PROVIDERS_PREFIX = 'portal.operations.providers'
export const OPERATORS_PROVIDER_INDEX = 3
